let DataUtils = {


    /**
     * Reads the specified file, using a promise.
     * 
     * @param {Object} file 
     * @returns 
     */
    readJSON: function(file) {
        console.log('Reading', file);

        return new Promise((resolve, reject) => {
            let reader = new FileReader();
    
            reader.onload = function () {
                try {
                    resolve(JSON.parse(reader.result));
                } catch (error) {
                    reject(error);
                }
            }
    
            reader.onerror = function () {
                reject(reader.error);
            };
    
            reader.readAsText(file);
        })
    }

}

export default DataUtils;